import m from "mithril";
import datamaanager from "../data-manager/data-manager";
import parentlist from "./parent-list/parent-list";

export default () => {
	const dm = new datamaanager();
	return {
		oninit: ({
			attrs: {
				tid,
				prid,
				category,
				defaultpagesize,
				appcode,
				tact,
				groups,
				blockcode,
				onSetHasNoData,
				hiddenFieldID,
				hiddenFieldColumn,
				selectsingle,
				showasfields,
				stripdata,
				fixed_editable,
			},
		}) => {
			paginate = false;
			pagesize = 10;
			if (!dm.initiated) dm.Initiate(tid, tact, prid, category, groups, paginate, pagesize);
		},
		view: ({
			attrs: {
				tid,
				prid,
				category,
				defaultpagesize,
				appcode,
				tact,
				groups,
				blockcode,
				onSetHasNoData,
				hiddenFieldID,
				hiddenFieldColumn,
				selectsingle,
				showasfields,
				stripdata,
				fixed_editable,
			},
		}) => {
			return m("div", dm.settingup ? "Loading" : dm.loading ? "...Loading" : m(parentlist, {data: dm.data}));
		},
	};
};
